import { createAction, createAsyncActionTypes } from '@mews/framework';
import { CommanderThunkAction } from '@mews-commander/types';
import { createBackgroundAction, createPollerActions } from '@mews-commander/utils';
import { prefix } from '../module';
import { isLoaded, getLastModified } from '../selectors/occupancyStatistics';
import { fetchOccupancy } from '../../occupancy/actions';
import { shouldFetch } from './util';

export const OCCUPANCY_STATISTICS_FETCH = prefix('OCCUPANCY_STATISTICS_FETCH');
export const OCCUPANCY_STATISTICS_RESET = prefix('OCCUPANCY_STATISTICS_RESET');
export const [
    OCCUPANCY_STATISTICS_FETCH_STARTED,
    OCCUPANCY_STATISTICS_FETCH_SUCCEEDED,
    OCCUPANCY_STATISTICS_FETCH_FAILED,
] = createAsyncActionTypes(OCCUPANCY_STATISTICS_FETCH);

const OCCUPANCY_STATISTICS_INTERVAL = 15 * 60 * 1000;

export const resetOccupancyStatistics = (): CommanderThunkAction => (dispatch) => {
    dispatch(createAction(OCCUPANCY_STATISTICS_RESET));
    dispatch(destroyOccupancyStatisticsPoller());
};

const shouldFetchOccupancyStatistics = shouldFetch(isLoaded, getLastModified, OCCUPANCY_STATISTICS_INTERVAL);
const fetchOccupancyStatistics =
    ({ start, end, serviceId }: $TSFixMe): CommanderThunkAction =>
    async (dispatch, getState, { appClockService }) => {
        const state = getState();

        if (!shouldFetchOccupancyStatistics(state, appClockService.getValue())) {
            return;
        }

        const promise = dispatch(fetchOccupancy(start, end, serviceId)).then(() => ({
            lastModified: appClockService.getValue(),
        }));
        return dispatch(createBackgroundAction(OCCUPANCY_STATISTICS_FETCH, promise));
    };

export const [startOccupancyStatisticsPoller, stopOccupancyStatisticsPoller, destroyOccupancyStatisticsPoller] =
    createPollerActions(fetchOccupancyStatistics, OCCUPANCY_STATISTICS_INTERVAL);
